"use strict";import{TableHead as e}from"./src/TableHead.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-table-head",e);
//# sourceMappingURL=sp-table-head.js.map
